import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  BackButton,
  CancelButton,
  EditButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import FilesView from "../../../../Components/Utils/FilesView";
import Modal from "../../../../Components/Utils/AttachmentView";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import { Tab, Tabs } from "../../../../Layouts/MainPage/Tabs";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import { NuInput } from "../../../../Components/Utils/Input";
import FireExtiguisherLayout from "./FireExtinguisherLayout";
import axiosInstance from "../../../../Services/axiosCommon";
import { GetAccess } from "../../../../Components/Utils/roles";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";

function ViewFireExtinguisher(onClose) {
  const [deliveryRows, setDeliveryRows] = useState([]);
  const { fireExtinguishersViewId } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("form");
  const crData = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
  const [createNew, setCreateNew] = useState({
    name: "",
  });

  const [data, setData] = useState(crData ? crData : null);

  const [isSubmit, setisSubmited] = useState(false);

  function getView() {
    axiosInstance
      .get(`/collection-and-returns/${fireExtinguishersViewId}`)
      .then((res) => {
        setData(res.data?.data);
        setisSubmited(res.data?.data?.isSubmited === true);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!crData) {
    getView();
    // }
  }, [fireExtinguishersViewId]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);
  const handleAddRow = () => {
    setDeliveryRows([
      ...deliveryRows,
      {
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
        col6: "",
        col7: "",
      },
    ]);
  };
  const handleInputChange = (e, rowIndex, key) => {
    const updatedRows = [...deliveryRows];
    updatedRows[rowIndex][key] = e.target.value;
    setDeliveryRows(updatedRows);
  };

  const id = fireExtinguishersViewId;
  const getUrl = `/collection-and-returns/get-status`;
  const putUrl = `/collection-and-returns/edit-status`;
  const statusUrl = "/collection-and-returns/all-status";


    const [showPdfComponent, setShowPdfComponent] = useState(false);

    const [viewPDF, setViewPDF] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);

  const ViewPDF = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/collection-and-returns/report/${id}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        }
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
      setPdfLoading(false);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
      setPdfLoading(false);
    }
  };

  const handlePdfIconClick = (id) => {
    setShowPdfComponent(true);
    ViewPDF(id);
  };

  return (
    <FireExtiguisherLayout
      BackButtonAccess={true}
      EditBttonAccess={GetAccess("fire_extinguisher_edit")}
    >
      {/* <div className="w-full h-full  px-4  "> */}
      {/* <div className="flex justify-end "> */}
      {/* <div className=" flex gap-2">
          <Link
            to={`/collectionAndreturn/fireExtinguisher`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          > 
            <BackButton link={true} />
          </Link>
          <Link
            to={`/collectionAndreturn/fireExtinguisher/edit/${fireExtinguishersViewId}`}
            state={{
              data: data,
              from: `/collectionAndreturn/fireExtinguisher/view/${fireExtinguishersViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div> */}
      {/* </div> */}
      <div className="w-full h-full mt-0.5 overflow-y-auto  ">
        <div className="w-full mx-auto h-[calc(100vh-165px)]   md:flex gap-2 text-[#111537] px-2 rounded-lg">
          <div className="md:w-[70%]  bg-white rounded-md drop-shadow-lg py-1 px-3  overflow-hidden ">
            <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-md sm:flex justify-between items-center  z-10">
              <div className="grid  items-center px-2 w-[70%]">
                <div className="grid  items-center ">
                  <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[100%]">
                    <p className="flex">{data?.refNumber}</p>
                  </div>
                  {/* <div className="flex gap-4 justify-between">
                 <p className="text-xs text-[#111537]">Date : 05-03-2025</p>
               </div> */}
                </div>
                {/* <div className="flex gap-4 ">
                <p className="text-xs text-[#111537]">Date : {data?.date ? (
    <NuDate value={data?.date} format="DD-MMM-YYYY" /> 
  ) : (
    "N/A"
  )}</p>
         <p className="text-xs text-[#111537]"> Created By : {data?.createdBy || 'None'}</p>

              </div> */}
              </div>

              {/* <div className="sm:mt-0 mt-1 border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto  flex-shrink-0  justify-center">
              <p className="  bg-white  text-black  p-2 rounded-l-full  ">
                Status{" "}
              </p>
              <p className="bg-baseColor-primary text-white p-2 items-center rounded-r-full">
                {" "}
                {data?.status || "None"}
              </p>
            </div> */}

              <div className=" flex items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                  Status{" "}
                </div>
                <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                  {data?.status || "-"}
                </div>
              </div>
            </div>

            <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
              <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
                <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
                  {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.Date ? (
                      <NuDate
                        value={data?.Date}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div> */}
                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Contract
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.contractRefNumber}
                    </p>
                  </div>

                  <div className="w-full flex px-2 ">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Collected By
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      :{" "}
                      {data?.collectors?.map((collectors, idx) => (
                        <span
                          key={idx}
                          className="text-xs font-medium  text-[#606279] mr-1 "
                        >
                          {collectors.assigneeName}
                          {idx < data.collectors.length - 1 && ","}
                        </span>
                      ))}
                    </p>
                  </div>

                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Collected Date
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      :{" "}
                      {data?.collectedOn ? (
                        <NuDate
                          value={data?.collectedOn}
                          format="DD-MMM-YYYY"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Return Date
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      :{" "}
                      {data?.deliveredOn ? (
                        <NuDate
                          value={data?.deliveredOn}
                          format="DD-MMM-YYYY"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                  {/* <div className="w-full flex px-2">
  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
    Amount
  </p>
  <p className="w-[65%] py-2 text-xs font-medium text-[#606279] ">
    : {data?.amount
        ? new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(data.amount)
        : '-'}
  </p>
</div> */}
                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Delivered By
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.deliveredByName || "-"}
                    </p>
                  </div>

                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Approved By
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.approvedByName || "-"}
                    </p>
                  </div>

                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Phone
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.phone || "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-4 mt-4">
                <div className="sm:w-[50%] w-full ">
                  <p className=" p-1 text-xs font-medium text-[#111537]">
                    Attachments
                  </p>
                  <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                    <div className="w-full flex gap-2 flex-wrap ">
                      {data?.attachments &&
                        filePathList.map((imgs, idx) => {
                          console.log("img", imgs);
                          return <FilesView fileView={imgs} key={idx} />;
                        })}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div> */}
            </div>
          </div>
          <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg   mt-3 md:mt-0">
            <div className="h-[98%] overflow-y-scroll p-2 ">
              {GetAccess("approvals") && isSubmit && (
                <ApprovalComponent
                  id={id}
                  getUrl={getUrl}
                  putUrl={putUrl}
                  statusUrl={statusUrl}
                  refSetData={setData}
                  data={data}
                  type={"collection-and-returns"}
                  preUrlName={"collection-and-returns"}
                />
              )}
              {GetAccess("client_details") && (
                <div className="w-full grid  border border-gary mt-4  rounded-lg">
                  <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                      Client Details
                    </p>
                  </div>

                  <div className="w-full flex px-2 justify-between">
                    <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                      Name
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                      : {data?.clientName}
                    </p>
                  </div>
                  <div className="w-full flex px-2 justify-between">
                    <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                      {" "}
                      Reference
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                      {" "}
                      : {data?.clientRefNumber}
                    </p>
                  </div>
                </div>
              )}

              <div className="w-full grid  border border-gary  rounded-lg mt-4 ">
                <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                  Report{" "}
                </p>
                <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                  <div
                    onClick={()=>handlePdfIconClick(fireExtinguishersViewId)}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                  >
                    <svg
                      width="20"
                      height="20"
                      className="fill-current text-baseColor-primary"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                    </svg>
                    <p className="w-auto text-[10px]">
                      {data?.ref || "FireExtinguisher form"}
                    </p>
                  </div>
                </div>
              </div>

              {/* {GetAccess("comments") &&(

            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
            )} */}
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
          <PDFViewer pdfFile={selectedImage?.file} />
        ) : (
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        )}
      </Modal>
            {showPdfComponent && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <button
              className="absolute top-2 right-2 text-white bg-red-600"
              onClick={() => setShowPdfComponent(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <PDFViewer pdfFile={viewPDF} isLoad={pdfLoading} />
          </div>
        </div>
      )}
      {/* </div> */}
    </FireExtiguisherLayout>
  );
}

export default ViewFireExtinguisher;
